// deps
import React, { ReactElement, memo } from "react";
import { ONE_BILL_DETAILS_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface OneLogoProps {
    width?: number;
    height?: number;
    className?: string;
}

const OneLiteLogoFull = (props: OneLogoProps): ReactElement => {
    const { height = 13, width = 66, className = "" } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            className={className}
            data-testid={ONE_BILL_DETAILS_TEST_IDS.ONE_LITE_LOGO}
        >
            <g opacity=".9">
                <path
                    fill="url(#a)"
                    d="M3.506 6.801c0-.848.409-1.535 1.146-1.742L3.26 3.764l1.22-1.79C1.644 2.26 0 4.386 0 6.8c0 2.16 1.312 4.107 3.618 4.702l.95-2.964c-.685-.234-1.062-.905-1.062-1.738Z"
                />
                <path
                    fill="#716C71"
                    d="M6.784 6.804c0 1.039-.587 1.827-1.648 1.827-.562 0-.986-.234-1.262-.61l-3.461.784c.72 1.667 2.361 2.885 4.724 2.885 3.26 0 5.154-2.29 5.154-4.888 0-2.596-1.894-4.867-5.154-4.867-.042 0-.083.003-.124.006l-.074.004L4.873 1 2.745 3.771l2.557 2.376V5.005a.34.34 0 0 0 .032.002c.01 0 .021 0 .031.002.917.106 1.42.851 1.42 1.795ZM17.179 11.46V6.321c0-.963-.512-1.328-1.327-1.328-.777 0-1.175.404-1.46.73v5.734h-3.41V2.167h3.41v1.057c.53-.615 1.535-1.289 3.146-1.289 2.123 0 3.052 1.308 3.052 2.925v6.6h-3.411Z"
                />
                <path
                    fill="#716C71"
                    fillRule="evenodd"
                    d="M21.258 6.804c0-2.694 2.028-4.867 4.985-4.867 2.69 0 4.757 1.962 4.757 5.232v.712h-6.216c.19.597.853 1.174 1.971 1.174.512 0 1.649-.25 2.104-.654l1.403 2.135c-.91.788-2.54 1.154-3.905 1.154-2.863 0-5.099-1.828-5.099-4.886Zm4.985-2.233c-1.042 0-1.384.692-1.497 1.116h3.013c-.095-.404-.417-1.116-1.517-1.116Z"
                    clipRule="evenodd"
                />
            </g>
            <rect width="30" height="11" x="35" y="1" fill="#fff" stroke="#02060C" strokeOpacity=".6" rx="3" />
            <path
                fill="#02060C"
                fillOpacity=".6"
                d="M41.024 9.883v-6.67h1.62v5.26h2.15v1.41h-3.77Zm5.55 0v-6.67h1.62v6.67h-1.62Zm4.777 0v-5.26h-1.43v-1.41h4.47v1.41h-1.42v5.26h-1.62Zm4.773 0v-6.67h4.02v1.39h-2.4v1.2h2.33v1.39h-2.33v1.3h2.4v1.39h-4.02Z"
            />
            <defs>
                <linearGradient id="a" x1="3.017" x2="2.203" y1="1.895" y2="7.938" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#fff" stopOpacity="0" />
                    <stop offset="1" stopColor="#7F7B7F" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default memo(OneLiteLogoFull);
